<template>
  <div class="navigation">
    <div class="banners-section">
      <v-list expand flat tile class="pa-0 ">
        <v-list-group
          value="true"
          :ripple="false"
          v-for="topcategory in topCategories"
          :key="topcategory._id"
        >
          <template v-slot:activator>
            <v-list-item-title
              class="subtitle-1 text-medium text-uppercase font-weight-black black--text"
              >{{ topcategory.name }}</v-list-item-title
            >
          </template>
          <v-list-item
            v-for="subcategory in topcategory.categories"
            link
            :ripple="false"
            :key="subcategory._id"
          >
            <v-btn-toggle
              v-model="category.activeCategories"
              multiple
              borderless
              active-class="active-category"
              tile
              dense
            >
              <v-btn
                text
                :ripple="false"
                small
                :value="subcategory._id"
                class="subtitle-1 pl-8"
                :class="[
                  category.activeCategories.includes(subcategory._id)
                    ? 'primary--text font-weight-bold '
                    : 'black--text font-weight-medium',
                ]"
                >{{ subcategory.name }}</v-btn
              >
            </v-btn-toggle>
          </v-list-item>
        </v-list-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

export default Vue.extend({
  name: "Navigation",
  computed: {
    ...mapGetters(["topCategories", "role"]),
    ...mapState(["category"]),
  },
  data() {
    return {
      lastCatQuery: "",
    };
  },
  // created() {
  //   const queryObj = this.$route.query;
  //   if (queryObj.category) {this.lastCatQuery = queryObj.category;}
  // },
  watch: {
    topCategories() {
      const queryObj = this.$route.query;
      if (queryObj.category) {
        this.updateByQuery(queryObj);
      }
    },
    "category.activeCategories"(newVal) {
      const selectedCat = this.topCategories
        .map((tc) => tc.categories)
        .flat()
        .filter((subCat) => newVal.includes(subCat._id));
      this.updateQueryParams(selectedCat.map((sc) => this.slugify(sc.name)));
    },
    "$route.query"(queryObj) {
      this.updateByQuery(queryObj);
    },
  },
  methods: {
    updateByQuery(queryObj) {
      const { category } = queryObj;
      if (category == undefined || this.lastCatQuery == category) return;
      this.lastCatQuery = category;

      const selectedCat = this.topCategories
        .map((tc) => tc.categories)
        .flat()
        .filter((subCat) =>
          category.split(",").includes(this.slugify(subCat.name))
        );
      this.category.activeCategories = selectedCat.map((sc) => sc._id);
    },
    slugify(str) {
      return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
    async updateQueryParams(selectedCategories) {
      const queryObj = Object.assign({}, this.$route.query);
      try {
        if (selectedCategories.length > 0) {
          queryObj.category = selectedCategories.sort().join(",");
          if (this.lastCatQuery == queryObj.category) return;
          this.lastCatQuery = queryObj.category;
          await this.$router.replace({
            query: queryObj,
          });
        } else {
          if (queryObj.category) {
            delete queryObj.category;
            this.lastCatQuery = "";
            await this.$router.replace({
              query: queryObj,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }

      // const qp = this.slugify(q);
      // return qp
      // try {
      //   const queryObj = Object.assign({}, this.$route.query);
      //   if (queryObj.category) {
      //     let currentCat = queryObj.category.split(",");
      //     if (!currentCat.includes(qp)) {
      //       currentCat.push(qp);
      //     } else {
      //       currentCat = currentCat.filter((c) => c !== qp);
      //       // console.log(currentCat);
      //     }

      //     if (currentCat.length > 0) {
      //       currentCat = currentCat.sort().join(",");
      //       queryObj.category = currentCat;
      //       await this.$router.replace({
      //         query: queryObj,
      //       });
      //     } else {
      //       delete queryObj.category;
      //       await this.$router.replace({
      //         query: queryObj,
      //       });
      //     }
      //   } else {
      //     await this.$router.replace({
      //       query: { category: qp },
      //     });
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.navigation {
  font-weight: 500;
  margin-left: -16px;
  overflow: auto;
  min-height: 100px;
  flex: 1;
}

// CUSTOMSCROLLBAR
.navigation::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: rgba(239, 63, 55, 0.1);
}

// CUSTOMSCROLLBAR END
.navigation::-webkit-scrollbar {
  -webkit-appearance: none; // you need to tweak this to make it available..
  width: 4px;
  background-color: transparent;
}

.navigation::-webkit-scrollbar-thumb {
  border: 0;
  background-color: rgba(239, 63, 55, 0.4);
  opacity: 0.4;
}

.v-btn:before {
  background-color: unset;
}

.nav-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.all-categories {
  cursor: pointer;
}

.all-cats,
.link {
  text-decoration: none;
  display: block;
  color: #000;
  cursor: pointer;
  position: relative;
  text-transform: uppercase;
}

.active-category {
  align-content: center;

  &::before {
    content: "";
    height: 2px;
    width: 10px;
    left: 0.65em;
    opacity: 1 !important;
    top: calc(50% - 1px);
    background-color: #ef3f37;
    display: block;
    position: absolute;
    transition: opacity 200ms;
  }
}

.v-list-group {
  margin-bottom: 2em;
}
</style>
